import { isDefined } from 'notable-common';
import { z } from 'zod';
import { FlowDurationSchema } from '../../../duration/duration.js';
import { FlowPrevisitFormSetStatus } from '../../../previsitFormSet/status.js';
import { FlowBlockValueUuidSchema } from '../../blockValue/uuidSchema.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
import { FlowFormBlockBaseConfigShape, checkFlowFormBlockEntityOverride, flowFormBlockEntityOverrideRefineMessage, } from './config.js';
import { FlowFormV2Mode, isFlowFormV2WaitMode } from './v2Mode.js';
export const FlowFormV2BlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.FormV2),
    config: FlowFormBlockBaseConfigShape.omit({ runMode: true })
        .extend({
        formTemplateConfigs: FlowFormBlockBaseConfigShape.shape.formTemplateConfigs.min(1, 'FormV2 requires at least one form template'),
        mode: z.enum(FlowFormV2Mode).optional().default(FlowFormV2Mode.AddAndWait),
        timeout: FlowDurationSchema.optional(),
        notificationSchemeIdOverride: FlowBlockValueUuidSchema({ isRequired: false }).nullish(),
    })
        .refine(checkFlowFormBlockEntityOverride, flowFormBlockEntityOverrideRefineMessage)
        .refine((config) => !isFlowFormV2WaitMode(config.mode) || isDefined(config.timeout), {
        message: 'A timeout is required when the FormV2 block waits for form set completion.',
        path: ['timeout'],
    }),
});
export const FlowFormsetTerminalStateSignalPayloadSchema = z.object({
    formSetId: z.string().optional(),
    formSetStatus: z.union([z.enum(FlowPrevisitFormSetStatus), z.string()]).optional(),
});
//# sourceMappingURL=configV2.js.map